import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environments';
import { PhoneSettingsResponse } from '../models/responses/phone-settings-response';
import { PhoneSettingsImportRequest } from '../models/requests/phone-settings-import-request';

@Injectable({
  providedIn: 'root'
})
export class PhoneSettingsService {

  constructor(private httpClient: HttpClient) { }

  purchasePhoneNumber(phoneNumber: string) {
    return this.httpClient.post<PhoneSettingsResponse>(`${environment.phoneSettingsUrl}/purchasePhoneNumber`, { phoneNumber });
  }

  fetchUserPhoneNumbers() {
    return this.httpClient.get<PhoneSettingsResponse[]>(`${environment.phoneSettingsUrl}/fetchUserPhoneNumbers`);
  }

  removeUserPhoneNumber(phoneSettingsId: number) {
    return this.httpClient.delete(`${environment.phoneSettingsUrl}/removeUserPhoneNumber/${phoneSettingsId}`);
  }

  importTwilioPhoneNumberToUser(request: PhoneSettingsImportRequest) {
    return this.httpClient.post(`${environment.phoneSettingsUrl}/importTwilioPhoneNumberToUser`, request)
  }

  updateImportedPhoneNumber(request: PhoneSettingsImportRequest) {
    return this.httpClient.put<PhoneSettingsResponse>(`${environment.phoneSettingsUrl}/updateImportedPhoneNumber`, request);
  }

  assignPhoneNumberToAiAgent(phoneSettingsId: number, aiAgentId: number) {
    return this.httpClient.put<PhoneSettingsResponse>(`${environment.phoneSettingsUrl}/assignPhoneNumberToAiAgent`, { phoneSettingsId, aiAgentId });
  }
  
  removePhoneNumberFromAiAgent(phoneSettingsId: number, aiAgentId: number) {
    return this.httpClient.put<PhoneSettingsResponse>(`${environment.phoneSettingsUrl}/removePhoneNumberFromAiAgent`, { phoneSettingsId, aiAgentId });
  }
}
